import {digitsEnToFa} from 'persian-tools2';
import * as Yup from 'yup';
import {registerSteps} from '../SignIn';

export const validationSchema = (currentStep, isScanCenter) => {
  if (currentStep === registerSteps.sendloginCode) {
    return Yup.object({
      phone: Yup.string()
        .trim()
        .matches(/^09\d{9}$/, {
          message: `شماره موبایل باید با ${digitsEnToFa(
            '09'
          )} شروع شود و  ${digitsEnToFa(11)} رقم باشد`,
        })
        .required('لطفا شماره موبایل خود را وارد کنید.'),
    });
  } else if (currentStep === registerSteps.signup) {
    if (isScanCenter) {
      return Yup.object({
        firstName: Yup.string()
          .trim()
          .min(3, `نام کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
          .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
          .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام اسکن کننده را فارسی وارد کنید.',
          })
          .nullable(true)
          .required('لطفا نام اسکن کننده را وارد کنید.'),

        lastName: Yup.string()
          .trim()
          .min(3, `نام خانوادگی کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
          .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
          .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام اسکن کننده را فارسی وارد کنید.',
          })
          .nullable(true)
          .required('لطفا نام خانوادگی را وارد کنید.'),

        scanCenterName: Yup.string()
          .trim()
          .min(3, `نام مرکز اسکن کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
          .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
          .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام مرکز اسکن را فارسی وارد کنید.',
          })
          .nullable(true)
          .required('لطفا نام مرکز اسکن را وارد کنید.'),

        address: Yup.string()
          .trim()
          .max(
            250,
            `شما تنها مجاز به نوشتن ${digitsEnToFa(250)} کارکتر میباشید.`
          )
          .nullable(true),
        cityId: Yup.object()
        .required('لطفا شهر خود را انتخاب کنید.'),
        provinceId: Yup.object()
        .required('لطفا استان خود را انتخاب کنید.'),
      });
    } else {
      return Yup.object({
        firstName: Yup.string()
          .trim()
          .min(3, `نام شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
          .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
          .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام را فارسی وارد کنید.',
          })
          .nullable(true)
          .required('لطفا نام خود را وارد کنید.'),
        lastName: Yup.string()
          .trim()
          .min(3, `نام خانوادگی کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
          .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
          .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام خانوادگی را فارسی وارد کنید.',
          })
          .nullable(true)
          .required('لطفا نام خانوادگی را وارد کنید.'),
      });
    }
  } else {
    return Yup.object({
      code: Yup.string()
        .trim()
        .min(4, `لطفا کد را بصورت کامل وارد کنید`)
        .required('لطفا کد ارسال شده به تلفن همراه خود را وارد کنید'),
    });
  }
};
